<div>
  @if (whereBackupStepLogic.supportedModsAndTypes || whereBackupStepLogic.nbfAndCantHybridVersion) {
    <ng-container *ngTemplateOutlet="hybridSwitcher"></ng-container>
  }

  @if (stepForm.controls.whereBackupStep.controls.IsHybridBackup.value) {
    <ng-container
      *ngTemplateOutlet="
        localStorage;
        context: {
          storage: whereBackupStepLogic.selectedLocalStorage,
          canDelete: false,
          blockTitle: 'wizards:whereBackup.destinations.primary' | i18next: { format: 'capitalize' }
        }
      "></ng-container>
    <ng-container
      *ngTemplateOutlet="
        notLocalStorage;
        context: {
          storage: whereBackupStepLogic.selectedNotLocalStorage,
          canDelete: true,
          blockTitle: 'wizards:whereBackup.destinations.secondary' | i18next: { format: 'capitalize' }
        }
      "></ng-container>
  } @else {
    <ng-container
      *ngTemplateOutlet="
        notLocalStorage;
        context: {
          storage: whereBackupStepLogic.selectedNotLocalStorage,
          canDelete: false,
          blockTitle: 'shared:common.backupDestination' | i18next: { format: 'capitalize' }
        }
      "></ng-container>
  }

  @if (whereBackupStepLogic.selectedNotLocalStorage && advancedOptionsAvailable) {
    <ng-container *ngTemplateOutlet="advancedOptionsButton"></ng-container>
  }
</div>

<ng-template #hybridSwitcher>
  <mbs-card
    class="mt-3"
    [customClasses]="'background-secondary'"
    [hasPadding]="false"
    [size]="MbsSize.xs">
    <div class="row mx-1 my-2 w-100">
      <div
        class="col-11"
        [class.text-muted]="!whereBackupStepLogic.supportedModsAndTypes">
        <strong>{{ 'wizards:whereBackup.useHybrid.text' | i18next }}</strong>
        <span
          class="cursor-help fa fa-info-circle text-info ml-1"
          container="body"
          placement="auto"
          [disableTooltip]="!whereBackupStepLogic.supportedModsAndTypes"
          [ngbTooltip]="'wizards:whereBackup.useHybrid.tooltip' | i18next"></span>
      </div>
      <div class="col-1">
        <mbs-switcher
          [disabledSelf]="!whereBackupStepLogic.supportedModsAndTypes"
          [selected]="stepForm.controls.whereBackupStep.controls.IsHybridBackup.value"
          (beforeUpdate)="beforeIsHybridBackupChangeHandler($event)"
          (change)="isHybridBackupChangeHandler($event)">
        </mbs-switcher>
      </div>
    </div>
    @if (!whereBackupStepLogic.supportedModsAndTypes) {
      <div class="d-flex align-items-center">
        <mbs-beta-feature-request
          [buildName]="betaFeatureBtnData.backupBuilds"
          [featureName]="betaFeatureBtnData.nbfHybrid"
          [version]="betaFeatureBtnData.agentVersionForNBFHybrid"></mbs-beta-feature-request>
      </div>
    }
  </mbs-card>
</ng-template>

<ng-template
  #localStorage
  let-blockTitle="blockTitle"
  let-canDelete="canDelete"
  let-storage="storage">
  @let touched = stepForm.controls.whereBackupStep.controls.HybridID.touched;
  <mbs-card
    class="mt-3"
    [customClasses]="'background-secondary'"
    [invalid]="isHybrid() && touched && !storage?.DisplayName"
    [size]="MbsSize.xs">
    <mbs-card-group>
      <div class="row">
        <ng-container
          *ngTemplateOutlet="
            storageInfo;
            context: { storage: storage, hybridMode: true, canDelete: canDelete, blockTitle: blockTitle }
          "></ng-container>
      </div>
    </mbs-card-group>

    @if (storage) {
      <mbs-card-group>
        <ng-container *ngTemplateOutlet="retention; context: { hybridMode: true }"></ng-container>
      </mbs-card-group>
    }
  </mbs-card>
</ng-template>

<ng-template
  #notLocalStorage
  let-blockTitle="blockTitle"
  let-canDelete="canDelete"
  let-storage="storage">
  @let touched = stepForm.controls.whereBackupStep.controls.ConnectionID.touched;
  <mbs-card
    class="mt-3"
    [customClasses]="'background-secondary'"
    [invalid]="isHybrid() && touched && !storage?.DisplayName"
    [size]="MbsSize.xs">
    <mbs-card-group>
      <div class="row">
        <ng-container
          *ngTemplateOutlet="
            storageInfo;
            context: { storage: storage, hybridMode: false, canDelete: canDelete, blockTitle: blockTitle }
          "></ng-container>
      </div>
    </mbs-card-group>

    @if (storage) {
      <mbs-card-group>
        <ng-container *ngTemplateOutlet="retention"></ng-container>
      </mbs-card-group>
    }
  </mbs-card>
</ng-template>

<ng-template
  #storageInfo
  let-blockTitle="blockTitle"
  let-canDelete="canDelete"
  let-hybridMode="hybridMode"
  let-storage="storage">
  <ng-container>
    <div
      class="d-flex flex-column"
      [class.col-10]="canDelete"
      [class.col-11]="!canDelete">
      <strong>{{ blockTitle }}</strong>

      @if (storage) {
        <div class="d-flex align-items-center overflow-hidden mb-2">
          <span
            class="mbs-storage mbs-storage-sm mbs-storage_{{ storage.StorageType | storageIcon: false : !storage.IsLocal }} mr-2"></span>
          <mbs-text-ellipsis [tooltip]="storage.DisplayName">{{ storage.DisplayName }}</mbs-text-ellipsis>
        </div>

        @if (!hybridMode && (storage.ImmutabilityPeriodDays || minPeriod)) {
          <div class="row">
            @if (!hybridMode && storage.ImmutabilityPeriodDays) {
              <div class="col-auto pr-0">
                <ng-container
                  *ngTemplateOutlet="lockAlert; context: { count: storage.ImmutabilityPeriodDays, isMinPeriod: false }"></ng-container>
              </div>
            }

            @if (!hybridMode && minPeriod) {
              <div class="col-auto pr-0">
                <ng-container *ngTemplateOutlet="lockAlert; context: { count: minPeriod, isMinPeriod: true }"></ng-container>
              </div>
            }
          </div>
        }
      } @else {
        <mbs-button
          type="link"
          [customClasses]="'px-0'"
          [loading]="whereBackupStepLogic.applyingCreatedDestination"
          (click)="handleAddDestination(null, hybridMode)">
          {{ 'wizards:selectDestinationTitle' | i18next }}
        </mbs-button>
      }
    </div>
    @if (storage) {
      <div
        class="destination-plus-retention_edit-buttons pr-0 m-0"
        [class.col-1]="!canDelete"
        [class.col-2]="canDelete">
        <div class="row mr-1">
          <mbs-button
            class="col p-0 px-1"
            container="body"
            [disabled]="isEdit && hybridMode"
            [icon]="'ico ico-Pencil'"
            [ngbTooltip]="'shared:buttons.edit' | i18next"
            [placement]="'top-right'"
            [type]="'secondary'"
            (click)="handleAddDestination(storage.ID, hybridMode)">
          </mbs-button>
          @if (canDelete && !(isEdit && hybridMode)) {
            <mbs-button
              class="col p-0"
              container="body"
              [icon]="'fa fa-trash'"
              [ngbTooltip]="'shared:buttons.delete' | i18next"
              [placement]="'top-right'"
              [type]="'secondary'"
              (click)="handleDeleteDestination(hybridMode)">
            </mbs-button>
          }
        </div>
      </div>
    }
  </ng-container>
</ng-template>

<ng-template
  #lockAlert
  let-count="count"
  let-isMinPeriod="isMinPeriod">
  <div class="mb-2 w-100">
    <span
      class="d-flex align-items-center"
      container="body"
      [disableTooltip]="isMinPeriod"
      [ngbTooltip]="lockAlertTooltip"
      [placement]="isMinPeriod ? 'right' : 'bottom'"
      [tooltipClass]="'tooltip-lg'">
      <ng-template #lockAlertTooltip>
        <span
          [innerHTML]="
            'wizards:whereBackup.tooltips.objectLockOnStorage' | i18next: { count: count, minPeriod: count } | safe: 'html'
          "></span>
      </ng-template>
      <span
        class="d-flex align-items-center justify-content-end text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
        <span class="ico ico-Lock"></span>
        <span class="ml-1">
          @if (isMinPeriod) {
            {{ 'wizards:retention.minStorageDuration' | i18next: { format: 'uppercase', count: count } }}
          } @else {
            {{ 'wizards:common.objectLockIsEnabled' | i18next: { format: 'uppercase', count: count } }}
          }
        </span>
      </span>
    </span>
  </div>
</ng-template>

<ng-template
  #retention
  let-hybridMode="hybridMode">
  <mbs-nbf-retention-policy-step-control-panel
    [alerts]="retentionPolicyStepLogic.alerts"
    [forceGFSShow]="true"
    [GFSInfo]="retentionPolicyStepLogic.GFSInfo"
    [isHybrid]="isHybrid()"
    [isWindows]="!isUnix"
    [layout]="'compact'"
    [mode]="
      hybridMode
        ? 'hybrid'
        : retentionPolicyStepLogic.schedule.isManualMode
          ? 'manual'
          : retentionPolicyStepLogic.schedule.isSimpleMode
            ? 'simple'
            : retentionPolicyStepLogic.schedule.isAdvancedMode
              ? 'advanced'
              : null
    "
    [parentForm]="stepForm.controls.retentionPolicyStep"
    [schedule]="retentionPolicyStepLogic.schedule"
    [storage]="retentionPolicyStepLogic.storage"
    (beforeGFSEnabledChange)="beforeGFSEnabledChangeHandler($event)"
    (clickDetailsGFS)="clickDetailsGFS()"
    (deleteVersionsOlderThanHybridChange)="deleteVersionsOlderThanHybridChangeHandler($event)"
    (GFSEnabledChange)="GFSEnabledChangeHandler()"
    (retentionChange)="retentionChangeHandler()"
    (retentionHybridChange)="retentionHybridChangeHandler()"
    (retentionUseDefaultSettingsChange)="retentionUseDefaultSettingsChangeHandler()"></mbs-nbf-retention-policy-step-control-panel>
</ng-template>

<ng-template #advancedOptionsButton>
  <div
    class="mt-3"
    [id]="elementSelectors.id.advancedOptionsButton">
    <mbs-button
      [type]="'secondary'"
      (click)="handleShowAdvancedOptions()">
      <i class="fa fa-cog"></i>
      <span>{{ 'wizards:advanced_options_title' | i18next }}</span>
    </mbs-button>
  </div>
</ng-template>

<ng-template #advancedOptions>
  <div class="mbs-advanced-options-step-modal_body max-hv-75 overflow-x-hidden overflow-y-auto">
    <ng-content></ng-content>
  </div>
</ng-template>
